import { defaultPosition, defaultRotation } from '@canvas-logic/clp-domain';
import { resolveNodeSettings } from './NodeSettings';
export class ViewNode {
    static getContainerNodeName(key) {
        return key + '_container';
    }
    static getContentNodeName(key) {
        return key + '_content';
    }
    constructor(key) {
        this.key = key;
        this.__ctx = null;
        this.modifiers = [];
        this.children = [];
        this.position = defaultPosition;
        this.rotation = defaultRotation;
        this.scale = { x: 1, y: 1, z: 1 };
        this.visible = true;
        this.settings = {};
        this.params = {};
    }
    init(params = {}) {
        this.params = params;
    }
    getPrefetchAssets() {
        return [];
    }
    setPosition(position) {
        this.position = position;
        return this;
    }
    setRotation(rotation) {
        this.rotation = rotation;
        return this;
    }
    setScale(scale) {
        this.scale = scale;
        return this;
    }
    setVisible(visible) {
        this.visible = visible;
        return this;
    }
    setSettings(settings) {
        this.settings = Object.assign(Object.assign({}, this.settings), settings);
        return this;
    }
    getSettings() {
        return resolveNodeSettings(this.settings);
    }
    addModifier(modifier) {
        this.modifiers.push(modifier);
        return this;
    }
    getModifiers() {
        return [...this.modifiers];
    }
    applyModifiers(obj, context) {
        return this.modifiers.reduce((currentObj, modifier) => {
            try {
                return modifier.apply(currentObj, context);
            }
            catch (error) {
                console.error(`Failed to apply modifier for node "${this.key}":`, error);
                return currentObj;
            }
        }, obj);
    }
}
//# sourceMappingURL=ViewNode.js.map